import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import config from "../../config/apiConfig";
import RatingCard from "../Report/RatingCard/RatingCard";
import Insight from "../Insight/Insight";
import "./Feedback.scss";
import ReactGA from "react-ga";

type Props = {
    visible: boolean;
    reviewed: boolean;
    close: () => void;
};

const Feedback: React.FC<Props> = (props) => {
    const { id } = useParams<{ id: string }>();

    const [feedback, setFeedback] = useState({
        conflict_interesting: 5,
        story_unique: 5,
        story_relevant: 5,
        story_engaging: 5,
        plot_predictable: 5,
        story_overall: 5,
        review_story_like: "",
        review_story_dislike: "",
        review_protagonist: "",
        review_story_characters: "",
    });

    useEffect(() => {
        let mounted = true;

        const formData = new FormData();
        formData.append("session-token", Cookies.get("token") ?? "");
        formData.append("token", config.token);
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        fetch(
            config.BASE_URL + "/v1/get/showmilers/story/" + id + "/reviews/all",
            requestOptions
        )
            .then((res) => res.json())
            .then((res) => {
                if (!res.data.length) return;
                if (mounted) setFeedback(res.data[0].payload);
            });

        return () => {
            mounted = false;
        };
    }, []);

    const handleFeedbackChange = (name: string, value: string | number) => {
        const data: { [key: string]: string | number } = { ...feedback };
        data[name] = value;
        setFeedback(data as any);
    };

    const handlePublish = async () => {
        ReactGA.event({
            category: "Read Story",
            action: "Provide feedback",
        });
        props.close();
        const formData = new FormData();
        formData.append("session-token", Cookies.get("token") ?? "");
        formData.append("token", config.token);
        formData.append("payload", JSON.stringify(feedback));
        const requestParams = {
            method: "POST",
            body: formData,
        };
        await fetch(
            config.BASE_URL + "/v1/put/showmilers/story/" + id + "/review/new",
            requestParams
        ).then(() => alert("Feedback Provided!"));
    };

    return (
        <div className="feedback_slide" hidden={!props.visible}>
            <div className="header">
                <h5>Give feedback</h5>
                <div>
                    <button
                        className="secondary__btn"
                        style={{ marginRight: 8 }}
                        onClick={props.close}
                    >
                        Cancel
                    </button>
                    {!props.reviewed && (
                        <button
                            className="primary__btn"
                            style={{ borderRadius: "18px", margin: 0 }}
                            onClick={handlePublish}
                        >
                            Submit
                        </button>
                    )}
                </div>
            </div>
            <div className="body">
                <RatingCard
                    question="How interesting is the problem/conflict?"
                    rating={feedback.conflict_interesting}
                    onChange={(v) =>
                        handleFeedbackChange("conflict_interesting", v)
                    }
                />
                <RatingCard
                    question="How unique is the story?"
                    rating={feedback.story_unique}
                    onChange={(v) => handleFeedbackChange("story_unique", v)}
                />
                <RatingCard
                    question="How relevant is the story?"
                    rating={feedback.story_relevant}
                    onChange={(v) => handleFeedbackChange("story_relevant", v)}
                />
                <RatingCard
                    question="How engaging is the story?"
                    rating={feedback.story_engaging}
                    onChange={(v) => handleFeedbackChange("story_engaging", v)}
                />
                <RatingCard
                    question="How much is the plot predictable?"
                    rating={feedback.plot_predictable}
                    onChange={(v) =>
                        handleFeedbackChange("plot_predictable", v)
                    }
                />
                <RatingCard
                    question="Overall Rating of the Story:"
                    rating={feedback.story_overall}
                    onChange={(v) => handleFeedbackChange("story_overall", v)}
                />
                <Insight
                    question="What did you like about the story?"
                    text={feedback.review_story_like}
                    setText={(v) =>
                        handleFeedbackChange("review_story_like", v)
                    }
                />
                <Insight
                    question="What did you not like about the story?"
                    text={feedback.review_story_dislike}
                    setText={(v) =>
                        handleFeedbackChange("review_story_dislike", v)
                    }
                />
                <Insight
                    question="Which characters in the story stay with you and why?"
                    text={feedback.review_story_characters}
                    setText={(v) =>
                        handleFeedbackChange("review_story_characters", v)
                    }
                />
                <Insight
                    question="Do you care what happens to the protagonist and why?"
                    text={feedback.review_protagonist}
                    setText={(v) =>
                        handleFeedbackChange("review_protagonist", v)
                    }
                />
            </div>
        </div>
    );
};

export default Feedback;
